import { render, staticRenderFns } from "./RelaysActiveChart.vue?vue&type=template&id=1bcc1e5a&scoped=true&"
import script from "./RelaysActiveChart.vue?vue&type=script&lang=js&"
export * from "./RelaysActiveChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc1e5a",
  null
  
)

export default component.exports